export default "assets/images/canei_white-6349c43b.png";